import React, { useState } from "react";

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const questions = [
    {
      question:
        "Quais órgãos são obrigados a divulgar informações no portal da transparência?",
      answer:
        "Os órgãos e entidades da Administração Direta e Indireta (Autarquias, Fundações, Empresas Públicas e Sociedades de Economia Mista).",
    },
    {
      question: "Quais as informações disponíveis no portal?",
      answer:
        "As informações referentes aos órgãos que compõem o Executivo Municipal, sendo elas: informações orçamentárias, receitas, despesas, investimentos públicos, balanços e prestações de contas da LRF, compras públicas, prestação de contas e gastos com a máquina pública.",
    },
    {
      question: "Quais as fontes das informações?",
      answer:
        "A fonte básica são os sistemas contábeis e financeiros da própria prefeitura.",
    },
    {
      question:
        "Como posso tirar dúvidas em relação aos termos técnicos presentes nos relatório?",
      answer:
        "Será disponibilizado um glossário explicando os termos e nomenclaturas, de forma simplificada.",
    },
    {
      question: "Que tipo de informações são encontradas no portal?",
      answer:
        "Gastos com servidores, investimento em obras, gastos correntes da máquina pública.",
    },
    {
      question: "É possível acessar informações sobre a arrecadação municipal?",
      answer:
        "Sim, as informações de arrecadação já estão disponíveis no site da prefeitura e ficarão também no portal da transparência.",
    },
    {
      question: "Que tipo de informações encontro nas Despesas?",
      answer:
        "São informações sobre o total das despesas, por órgão, por função, por programa e/ou por credor. Há também informações sobre valor orçado, valor empenhado, liquidado ou pago e o credor.",
    },
  ];

  return (
    <div className="space-y-4">
      {questions.map((item, index) => (
        <div
          key={index}
          className="border border-gray-300 rounded-lg shadow-sm"
        >
          <button
            onClick={() => toggleIndex(index)}
            className="w-full text-left px-4 py-3 bg-gray-100 text-gray-800 font-medium flex justify-between items-center"
          >
            {item.question}
            <span className="text-lg">{openIndex === index ? "−" : "+"}</span>
          </button>
          {openIndex === index && (
            <div className="px-4 py-3 text-gray-700 bg-white">
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQs;
